import {useEffect, useState} from 'react';

import {AppEventsLogger} from 'react-native-fbsdk-next';

import {RegiaoDTO} from '../../dtos/RegiaoDTO';

import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {RootStackParamList} from '../../dtos/RoutesDTO';
import {RegionsList} from '../../components/shared/RegionsList';
import {Platform} from 'react-native';
import {addInAppTrigger} from '../../lib/pushMessaging';
import {useLocalization} from '../../context/localization';
import {useFocusEffect} from '@react-navigation/native';
import { Loading } from '../../components/Interface/Loadings/Loading';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'Localization'>;

export function Localization({navigation, route}: ScreenProps) {
  const {tipo} = route.params;
  
  useEffect(() => {
    if (Platform.OS !== 'web') {
      addInAppTrigger('screen', 'fuel_localization');
    }
  }, []);

  function oneCityAction(item: RegiaoDTO) {
    navigation.push('ListagemPostos', {
      cidade: item.cidades[0].cidade,
      tipo,
      localidade: item._id,
      isUserLocation: false,
    });
    AppEventsLogger.logEvent('clique_regiao_direta', {
      cidade: item.cidades[0].cidade,
      regiao: JSON.stringify(item.cidades[0].regioes),
    });
  }

  function manyCitiesAction(item: RegiaoDTO) {
    navigation.push('SubRegions', {
      data: item,
      tipo,
    });
    AppEventsLogger.logEvent('clique_regiao', {
      regiao: JSON.stringify(item.cidades[0].regioes),
    });
  }

  return (
    <>
    <RegionsList
      tipo={tipo}
      
      manyCitiesAction={manyCitiesAction}
      oneCityAction={oneCityAction}
    />
    </>
  );
}
